var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42181 6.3515H19.9993C20.315 6.35151 20.6271 6.41766 20.9156 6.54569C21.2041 6.67372 21.4626 6.86078 21.6744 7.09481C21.8862 7.32885 22.0466 7.60466 22.1453 7.90448C22.244 8.2043 22.2787 8.52147 22.2473 8.83555L21.5695 15.6133C21.5138 16.1708 21.2529 16.6877 20.8375 17.0636C20.4221 17.4395 19.8818 17.6477 19.3216 17.6478H8.53365C8.01117 17.648 7.50476 17.4671 7.10066 17.1359C6.69655 16.8047 6.41973 16.3437 6.31733 15.8313L4.42181 6.3515Z",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42183 6.35151L3.50684 2.68813C3.44564 2.44386 3.30458 2.22703 3.10606 2.0721C2.90753 1.91717 2.66293 1.83301 2.4111 1.83301H1.03296",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81073 22.1663H10.07",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8477 22.1663H19.1069",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.73cf8cc4409a717c1c7a3e349d20cdcf.svg";
export { ForwardRef as ReactComponent };